type NavigatorWithMemory = Navigator & {
	deviceMemory?: number;
};

const parseBrowser = (userAgent: string) => {
	const rules: Array<[string, RegExp]> = [
		["Edge", /Edg\/(\d+(?:\.\d+)?)/],
		["Chrome", /Chrome\/(\d+(?:\.\d+)?)/],
		["Firefox", /Firefox\/(\d+(?:\.\d+)?)/],
		["Safari", /Version\/(\d+(?:\.\d+)?).*Safari/],
	];

	for (const [name, regex] of rules) {
		const match = userAgent.match(regex);
		if (match?.[1]) {
			return {
				browserName: name,
				browserVersion: match[1],
				browserMajorVersion: Number.parseInt(match[1].split(".")[0], 10),
			};
		}
	}

	return {
		browserName: "Unknown",
		browserVersion: undefined,
		browserMajorVersion: undefined,
	};
};

export const collectBrowserTelemetry = () => {
	const nav = navigator as NavigatorWithMemory;
	const userAgent = nav.userAgent || "";
	const browser = parseBrowser(userAgent);

	return {
		userAgent,
		...browser,
		platform: nav.platform,
		screenWidth: window.screen?.width,
		screenHeight: window.screen?.height,
		viewportWidth: window.innerWidth,
		viewportHeight: window.innerHeight,
		devicePixelRatio: window.devicePixelRatio,
		orientation: window.screen?.orientation?.type,
		language: nav.language,
		languages: nav.languages?.join(","),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		hardwareConcurrency: nav.hardwareConcurrency,
		deviceMemory: nav.deviceMemory,
		maxTouchPoints: nav.maxTouchPoints,
		referrer: document.referrer,
		pageTitle: document.title,
		visibilityState: document.visibilityState,
	};
};

export const getEnvironmentFingerprint = () => {
	const telemetry = collectBrowserTelemetry();
	return JSON.stringify({
		userAgent: telemetry.userAgent,
		browserName: telemetry.browserName,
		browserMajorVersion: telemetry.browserMajorVersion,
		platform: telemetry.platform,
		screenWidth: telemetry.screenWidth,
		screenHeight: telemetry.screenHeight,
		devicePixelRatio: telemetry.devicePixelRatio,
		language: telemetry.language,
		timezone: telemetry.timezone,
	});
};
